import Vue from 'vue'
import Router from 'vue-router'

const detailLayout = () => import('@/components/detailLayout.vue')
const listLayout = () => import('@/components/listLayout.vue')
const recentLayout = () => import('@/components/mostRecententLayout.vue')
const addRutto = () => import('@/components/addRutto.vue')
const info = () => import('@/components/info.vue')
const cookieInfo = () => import('@/components/cookie-info.vue')

Vue.use(Router)

export default new Router({
	routes: [
		{
			path: '/',
			name: 'Migliori rutti',
			component: listLayout,
		},
		{
			path: '/ruttirecenti',
			name: 'Rutti recenti',
			component: recentLayout,
		},
		{
			path: '/detail/:videoID',
			name: 'Video rutto',
			component: detailLayout,
			props:true,
		},
		{
			path: '/aggiungirutto',
			name: 'Aggiungi Rutto',
			component: addRutto,
		},
		{
			path: '/info',
			name: 'info',
			component: info,
		},
		{
			path: '/cookie-policy',
			name: 'cookie-policy',
			component: cookieInfo,
		},
	],
})


// WEBPACK FOOTER //
// ./src/router/index.js